<template>
	<section>
		<div class="user-panel">
			<header>Dane podstawowe</header>
			<dl>
				<dt>NIP</dt>
				<dd>{{ myFx.nip }}</dd>

				<dt>REGON</dt>
				<dd>{{ myFx.regon }}</dd>

				<dt>KRS</dt>
				<dd>{{ myFx.krs }}</dd>

				<dt>Urząd skarbowy</dt>
				<dd>{{ myFx.taxOffice }}</dd>
			</dl>
		</div>
		<div class="user-panel">
			<header>Dane kontaktowe</header>
			<dl>
				<dt>Adres siedziby</dt>
				<dd>
					<address-preview :address="myFx.headquatersAddress" />
				</dd>

				<dt>Adres na potrzeby PIT</dt>
				<dd>
					<template v-if="myFx.pitAddressLikeMainAddress"
						>Ten sam co siedziba firmy</template
					>
					<template v-else>
						<address-preview :address="myFx.pitAddress" />
					</template>
				</dd>

				<dt>Kraj siedziby</dt>
				<dd>{{ myFx.country }}</dd>

				<dt>Adres do korespondencji</dt>
				<dd>
					<template v-if="myFx.correspondenceAddressLikeMainAddress">
						Ten sam co siedziba firmy
					</template>
					<template v-else>
						<address-preview :address="myFx.correspondAddress" />
					</template>
				</dd>
			</dl>
		</div>
		<div class="user-panel">
			<header>Dane pełnomocnika</header>
			<dl>
				<dt>Imię i Nazwisko</dt>
				<dd>
					{{ myFx.proxyAccount.firstName }}
					{{ myFx.proxyAccount.lastName }}
				</dd>

				<dt>Data urodzenia</dt>
				<dd>
					{{ $filters.date(myFx.proxyAccount.dateOfBirth) }}
				</dd>

				<dt>PESEL</dt>
				<dd>{{ myFx.proxyAccount.pesel }}</dd>

				<dt>Dokument tożsamości</dt>
				<dd>
					{{ myFx.proxyAccount.documentType }}:
					{{ myFx.proxyAccount.documentNumber }}
				</dd>

				<dt>Obywatelstwo</dt>
				<dd>{{ myFx.proxyAccount.citizenship }}</dd>

				<dt>Numer telefonu</dt>
				<dd>{{ myFx.proxyAccount.phoneNumber }}</dd>

				<dt>e-mail</dt>
				<dd>{{ myFx.proxyAccount.email }}</dd>

				<dt>Adres zameldowania</dt>
				<dd>
					<address-preview
						:address="myFx.proxyAccount.mainProxyAddress"
					/>
				</dd>
			</dl>
		</div>
		<div class="user-panel">
			<header>Dane teleadresowe firmy</header>
			<dl>
				<dt>e-mail</dt>
				<dd>{{ myFx.email }}</dd>

				<dt>Numer telefonu</dt>
				<dd>{{ myFx.mobilePhone }}</dd>

				<dt>Hasło telefoniczne</dt>
				<dd>{{ myFx.phonePassword }}</dd>
			</dl>
		</div>
		<div class="user-panel">
			<header>Rachunki bankowe do wpłat NRB</header>
			<dl>
				<template v-for="(account, i) in bankAccountList">
					<dt v-if="account.clientAccount" :key="'a' + i">
						{{ account.clientDescription }}
					</dt>
					<dd v-if="account.clientAccount" :key="'b' + i">
						{{ account.nrb }}
					</dd>
				</template>
			</dl>
			<!-- old version -->
			<!-- <template v-for="(account, i) in bankAccountList">
                <dl v-if="account.clientAccount" :key="i">
                    <dt v-if="account.name">{{ account.name }}</dt>
                    <dd>{{ account.nrb }} {{ account.clientDescription }}</dd>
                </dl>
            </template> -->
		</div>
		<div class="user-panel">
			<header>Rachunki bankowe do wypłat</header>
			<dl>
				<template v-for="(account, i) in bankAccountList">
					<dt v-if="!account.clientAccount" :key="'a' + i">
						{{ account.clientDescription }}
					</dt>
					<dd v-if="!account.clientAccount" :key="'b' + i">
						{{ account.nrb }}
					</dd>
				</template>
			</dl>
			<!-- old version -->
			<!-- <template v-for="(account, i) in bankAccountList">
                <dl v-if="!account.clientAccount" :key="i">
                    <dt>{{ account.name }}</dt>
                    <dd>{{ account.nrb }} {{ account.clientDescription }}</dd>
                </dl>
            </template> -->
		</div>
		<div class="user-panel">
			<header>Pozostałe informacje</header>
			<dl>
				<dt>Oddział</dt>
				<dd v-if="myFx.pok">{{ myFx.pok }}</dd>
				<dd v-else>Brak</dd>
			</dl>
		</div>
	</section>
</template>

<script>
import AddressPreview from '@/components/AddressPreview';
import { getDictionaryItem } from '@/mixins/get-dictionary-item';

export default {
	components: {
		AddressPreview,
	},
	mixins: [getDictionaryItem],
	computed: {
		myFx() {
			return this.$store.getters.getMyFx
				? this.$store.getters.getMyFx
				: false;
		},
		dictCountries() {
			return this.$store.getters.getCountries
				? this.$store.getters.getCountries
				: false;
		},
		bankAccountList() {
			return this.$store.getters.getBankAccountList
				? this.$store.getters.getBankAccountList
				: false;
		},
	},
	updated() {
		this.$store.commit('setMyFx', this.myFx);
	},
};
</script>
